// import banner from "../../Assets/Banners/aboutus.png";
import banner2 from "../../Assets/Banners/About-us.jpg";
const Aboutimage = {
  // banner: banner,
  banner2: banner2,
};
export default Aboutimage;
